import React from 'react';
import {
  PlainButton,
  PaddingWrapper,
  DrawerHeader,
} from 'components/styled-components';
import { Drawer } from '@blueprintjs/core';
import FormTextGroup from 'components/forms/components/form-text-group';
import FormSelectGroup from 'components/forms/components/form-select-group';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import filter from 'lodash/filter';

const UserSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(1, 'Too Short!')
    .max(200, 'Too Long!')
    .required('Required'),
  lastName: Yup.string()
    .min(1, 'Too Short!')
    .max(200, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .min(1, 'Too Short!')
    .max(200, 'Too Long!')
    .email('Invalid email')
    .required('Required'),
  thirdParties: Yup.array().of(Yup.object())
    .min(1, 'Third Party Required')
	.required('Required')
});

const initialValues = { firstName: '', lastName: '', email: '', thirdParties: [] };

const UserDrawer = ({ isOpen, handleCloseDrawer, handleSaveUser, vendors }) => {
  return (
    <Drawer isOpen={isOpen} onClose={handleCloseDrawer}>
      <Formik
        initialValues={initialValues}
        validationSchema={UserSchema}
        onSubmit={handleSaveUser}
      >
        {({ isSubmitting, values, handleChange }) => (
          <Form>
            <DrawerHeader>
              <span>Add User</span>
              <div>
                <PlainButton type="submit" disabled={isSubmitting}>
                  SAVE
                </PlainButton>
              </div>
            </DrawerHeader>
            <PaddingWrapper padding="2rem">
              <FormTextGroup
                label="First Name"
                requiredLabel={true}
                name="firstName"
                value={values.firstName}
                handleChange={handleChange}
              />
              <FormTextGroup
                label="Last Name"
                requiredLabel={true}
                name="lastName"
                value={values.lastName}
                handleChange={handleChange}
              />
              <FormTextGroup
                label="Email Address"
                requiredLabel={true}
                name="email"
                value={values.email}
                handleChange={handleChange}
              />
			<FormSelectGroup
				label="Third Party Name"
				requiredLabel={true}
				name="thirdParties"
				asyncOptions={vendors}
				labelKey="vendorName"
				valueKey="vendorID"
				value={values.thirdParties}
				onChange={(key, value) => {
					handleChange({target: {name: key, value: value}});
				}}
				isClearable={true}
				multi
			/>
            </PaddingWrapper>
          </Form>
        )}
      </Formik>
    </Drawer>
  );
};

export default UserDrawer;
